
import { ProductCategory } from "@/script/apps/shop/entity/ShopEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ProductCategoryService } from "@/script/apps/shop/service/ProductCategoryService";

@Options({})
export default class ProductCategoryList extends BaseList {
  private queryEntity: ProductCategory = {};

  private dataList: ProductCategory[] = [];

  private service = new ProductCategoryService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_shop_category",
      "/shop/product_category",
      "/shop/product_category",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const currDataList: ProductCategory[] = data.list as ProductCategory[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
  }
}
